module.exports = __webpack_public_path__ + "img/391.aad0bb64.jpg";